export default __webpack_public_path__ + "static/media/H0005.08b1ddd2.png";